import FuzzySearch from 'fuzzy-search';

export default FuzzySearch;
